import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLocale } from '@/hooks/use-locale';
import { ModeToggle } from '@/components/mode-toggle';
import { LocaleSwitcher } from '@/components/locale-switcher';
import { env } from '@/lib/env';

export function Footer() {
  const { t } = useTranslation('common');
  const { t: ts } = useTranslation('services');
  const { lang } = useLocale();
  const base = `/${lang}`;
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-border bg-background">
      <div className="container-editorial py-16">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="space-y-4">
            <Link to={`${base}/`} className="flex items-center gap-2">
              <span className="inline-flex items-center justify-center w-8 h-8 rounded-md bg-primary text-primary-foreground font-display font-bold text-sm">
                NT
              </span>
              <span className="font-display font-semibold">{t('app.name')}</span>
            </Link>
            <p className="text-sm text-muted-foreground max-w-xs">{t('app.tagline')}</p>
            <div className="flex items-center gap-2">
              <LocaleSwitcher />
              <ModeToggle />
            </div>
          </div>

          <div>
            <h3 className="font-display text-sm font-semibold mb-3">{t('nav.services')}</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <Link className="hover:text-foreground transition-colors" to={`${base}/servicios#crear`}>
                  {ts('items.crear.name')}
                </Link>
              </li>
              <li>
                <Link className="hover:text-foreground transition-colors" to={`${base}/servicios#actualizar`}>
                  {ts('items.actualizar.name')}
                </Link>
              </li>
              <li>
                <Link className="hover:text-foreground transition-colors" to={`${base}/servicios#validar`}>
                  {ts('items.validar.name')}
                </Link>
              </li>
              <li>
                <Link className="hover:text-foreground transition-colors" to={`${base}/servicios#migrar`}>
                  {ts('items.migrar.name')}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-display text-sm font-semibold mb-3">{t('footer.resources')}</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <Link className="hover:text-foreground transition-colors" to={`${base}/portfolio`}>
                  {t('nav.portfolio')}
                </Link>
              </li>
              <li>
                <Link className="hover:text-foreground transition-colors" to={`${base}/proceso`}>
                  {t('nav.process')}
                </Link>
              </li>
              <li>
                <Link className="hover:text-foreground transition-colors" to={`${base}/sobre-el-servicio`}>
                  {t('nav.about')}
                </Link>
              </li>
              <li>
                <Link className="hover:text-foreground transition-colors" to={`${base}/faq`}>
                  {t('nav.faq')}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-display text-sm font-semibold mb-3">{t('nav.contact')}</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <Link className="hover:text-foreground transition-colors" to={`${base}/contacto`}>
                  {t('nav.contact')}
                </Link>
              </li>
              <li>
                <a className="hover:text-foreground transition-colors" href={`mailto:${env.VITE_CONTACT_EMAIL}`}>
                  {env.VITE_CONTACT_EMAIL}
                </a>
              </li>
              <li className="font-mono text-xs pt-2">{t('footer.location')}</li>
            </ul>
          </div>
        </div>

        <div className="hairline my-8" />

        <div className="flex flex-wrap items-center justify-between gap-4 text-xs text-muted-foreground">
          <p>{t('footer.copyright', { year })}</p>
          <ul className="flex flex-wrap gap-4">
            <li>
              <Link className="hover:text-foreground transition-colors" to={`${base}/legal/privacidad`}>
                {t('footer.privacy')}
              </Link>
            </li>
            <li>
              <Link className="hover:text-foreground transition-colors" to={`${base}/legal/terminos`}>
                {t('footer.terms')}
              </Link>
            </li>
            <li>
              <Link className="hover:text-foreground transition-colors" to={`${base}/legal/cookies`}>
                {t('footer.cookies')}
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
}
